import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Box } from '@mui/material';
// import CompanyLogo from '../../../Assets/img/Neoin-logo.png'
// import DefaultProfile from "../../../Assets/img/Default-Profile.png"
// import { Box } from '@mui/material';
import "../../../Assets/css/card.css";
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
// import { MdOutlinePhoneIphone } from "react-icons/md";
import { useQuantityContext } from '../../QuantityContext';
// import { BsHeart, BsHeartFill } from 'react-icons/bs';
// import { FaStar } from 'react-icons/fa';
import DefaultProfileBg from "../../../Assets/img/card/profilebg.png"
import { useUserDetailContext } from '../../UserDetailContext';
import Nofavourites from "../../../Assets/img/No-favourite.svg"
// import PublicIcon from '@mui/icons-material/Public';
import { AllCardLayouts } from './Layouts2';
import loaderGif from '../../../Assets/img/icons/Animation - 1718370478484.gif'
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const FavouriteCards = () => {
    const apiKey = process.env.REACT_APP_API_KEY
    const { quantity, sortOrder, sortDateOrder, latestDateOrder } = useQuantityContext();
    const { setOtherCards, cardDetailsAll, cardStylesAll, cards, setCards, userDetails, favoriteCards, setFavoriteCards } = useUserDetailContext();
    const objectId = localStorage.getItem("objectId");
    const AllCards = useSelector((state) => state?.CardArray?.AllCardDetailsInfo);

    axios.defaults.baseURL = `${process.env.REACT_APP_BACKEND_URL}`;
    const [loading, setLoading] = useState(false);

    // const handleCardTypeCustomize = (category) => {
    //     updateCardDetails({ "customizeCategory": category });
    // }
    const todayDate = new Date();

    useEffect(() => {
        if (sortOrder !== null) {
            const sortedCards = [...AllCards].sort((a, b) => {
                if (sortOrder === 'ascending') {
                    return a.card_name.localeCompare(b.card_name);
                } else {
                    return b.card_name.localeCompare(a.card_name);
                }
            });
            setOtherCards(sortedCards);
        }
    }, [sortOrder]);

    useEffect(() => {
        if (sortDateOrder !== null) {
            const sortedCards = [...AllCards].sort((a, b) => {
                const dateA = new Date(a.created_at);
                const dateB = new Date(b.created_at);

                return sortDateOrder === 'ascending' ? dateA - dateB : dateB - dateA;
            });

            setOtherCards(sortedCards);
        }
    }, [sortDateOrder]);

    useEffect(() => {
        if (latestDateOrder !== null) {
            const sortedCards = [...AllCards].sort((a, b) => {
                const dateA = new Date(a.modified_at);
                const dateB = new Date(b.modified_at);

                if (latestDateOrder === 'latestDate') {
                    return dateB - dateA; // Latest date first
                } else {
                    return dateA - dateB; // Earliest date first
                }
            });

            setOtherCards(sortedCards);
        }
    }, [latestDateOrder]);

    const [ContactStylesForGenZ, setContactStylesForGenZ] = useState({
        User_ID: objectId,
        CardType: 'GenZ',
        callNo: { input: `${userDetails.phone}`, visible: true },
        textNo: { input: `${userDetails.phone}`, visible: true },
        emailId: { input: `${userDetails.email}`, visible: true },
        whatsapp: { input: `${userDetails.phone}`, visible: true },
    });

    const headers = {
        'x-api-key': apiKey,
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${objectId}`
    };

    // useEffect(() => {
    //     const fetchCardDetailsAndStyles = async (cardType) => {
    //         try {
    //             const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/card/getParticularCardInfo`, {
    //                 params: {
    //                     CardName: cardType,
    //                     referenceId: objectId
    //                 },
    //                 headers: headers
    //             });

    //             const initialCardDetails = {
    //                 User_ID: objectId,
    //                 CardType: cardType,
    //                 prefix: '',
    //                 suffix: '',
    //                 title: '',
    //                 nickname: '',
    //                 summary: '',
    //                 designation: '',
    //                 company: '',
    //                 profile_pic: '',
    //                 logo: ''
    //             };
    //             const initialCardStyles = {
    //                 User_ID: objectId,
    //                 CardType: cardType,
    //                 font: '',
    //                 size: '',
    //                 style: '',
    //                 colorPrimary: '',
    //                 colorSecondary: '',
    //                 colorTitle: '',
    //                 colorLayout: '#0044c6',
    //                 bgColor: '#ffff',
    //                 layoutStyle: (cardType === 'Personal' || cardType === 'Customize_Personal') ? '2' : '1',
    //             };

    //             console.log(`Fetched card details for ${cardType}:`, response.data);

    //             if (response.data.Details.length > 0) {
    //                 const details = response.data.Details[0];
    //                 const { user_ref_id, ...restDetails } = details;
    //                 const renamedDetails = {
    //                     ...restDetails,
    //                     User_ID: user_ref_id,
    //                 };

    //                 if (cardType === 'Professional') {
    //                     setCardDetailsForProfessional(renamedDetails);
    //                 } else if (cardType === 'Personal') {
    //                     setCardDetailsForPersonal(renamedDetails);
    //                 } else if (cardType === 'Student') {
    //                     setCardDetailsForStudent(renamedDetails);
    //                 } else if (cardType === 'GenZ') {
    //                     setCardDetailsForGenZ(renamedDetails);
    //                 }
    //             }


    //             if (response.data.CardDesigns.length > 0) {
    //                 if (cardType === 'Professional') {
    //                     setCardStylesForProfessional(response.data.CardDesigns[0]);
    //                 } else if (cardType === 'Personal') {
    //                     setCardStylesForPersonal(response.data.CardDesigns[0]);
    //                 } else if (cardType === 'Student') {
    //                     setCardStylesForStudent(response.data.CardDesigns[0]);
    //                 } else if (cardType === 'GenZ') {
    //                     setCardStylesForGenZ(response.data.CardDesigns[0]);
    //                 }
    //             }

    //         } catch (error) {
    //             console.error(`Error fetching card details for ${cardType}:`, error);
    //         }
    //     };

    //     cards.forEach(cardType => {
    //         fetchCardDetailsAndStyles(cardType);
    //     });
    // }, [cards]);

    useEffect(() => {
        if (sortOrder !== null) {
            const sortedCards = [...AllCards].sort((a, b) => {
                if (sortOrder === 'ascending') {
                    return a.card_name.localeCompare(b.card_name);
                } else {
                    return b.card_name.localeCompare(a.card_name);
                }
            });
            setOtherCards(sortedCards);
        }
    }, [sortOrder]);

    useEffect(() => {
        if (sortDateOrder !== null) {
            const sortedCards = [...AllCards].sort((a, b) => {
                const dateA = new Date(a.created_at);
                const dateB = new Date(b.created_at);

                return sortDateOrder === 'ascending' ? dateA - dateB : dateB - dateA;
            });

            setOtherCards(sortedCards);
        }
    }, [sortDateOrder]);

    useEffect(() => {
        if (latestDateOrder !== null) {
            const sortedCards = [...AllCards].sort((a, b) => {
                const dateA = new Date(a.modified_at);
                const dateB = new Date(b.modified_at);

                if (latestDateOrder === 'latestDate') {
                    return dateB - dateA; // Latest date first
                } else {
                    return dateA - dateB; // Earliest date first
                }
            });

            setOtherCards(sortedCards);
        }
    }, [latestDateOrder]);

    const updateFavoriteCards = async (User_ID, cardName, isFavorite) => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/card/updateCardFavourite`,
                { User_ID, card_name: cardName, is_favourite: isFavorite },
                {
                    headers: headers
                }
            );
            console.log('Updated favorite card:', response.data);
        } catch (error) {
            console.error('Error updating favorite card:', error.response.data.message);
        }
    };


    const handleFavoriteClick = async (card) => {
        const isFavorite = favoriteCards.includes(card);
        // Update the favorite cards state
        setFavoriteCards((prevFavorites) => {
            if (prevFavorites.includes(card)) {
                // If the card is already in favorites, remove it
                return prevFavorites.filter(favCard => favCard !== card);
            } else {
                // Otherwise, add it to the favorites
                return [...prevFavorites, card];
            }
        });

        const User_ID = objectId.trim();
        await updateFavoriteCards(User_ID, card, !isFavorite); // dont change the logic of isFavourite
    };

    const getFontWeight = (style) => {
        switch (style) {
            case 'Light':
                return 300; // Font weight for Light
            case 'Regular':
                return 500; // Font weight for Regular
            case 'Medium':
                return 600; // Font weight for Medium
            case 'Semi Bold':
                return 700; // Font weight for Semi Bold
            case 'Bold':
                return 800; // Font weight for Bold
            default:
                return 'normal'; // Default font weight
        }
    };

    const initialDialogsState = cards.reduce((acc, card) => {
        acc[card] = false;
        return acc;
    }, {});

    const [dialogs, setDialogs] = useState({
        // Personal: false,
        // Professional: false,
        // Student: false,
        // GenZ: false
        initialDialogsState
    });

    const handleOpenDialog = (type) => {
        setDialogs((prevDialogs) => ({
            ...prevDialogs,
            [type]: true
        }));
    };

    const handleCloseDialog = (type) => {
        setDialogs((prevDialogs) => ({
            ...prevDialogs,
            [type]: false
        }));
    };

    const [sharePops, setSharePops] = useState({
        // Personal: false,
        // Professional: false,
        // Student: false,
        // GenZ: false
        initialDialogsState
    });

    const handleShareClick = (type) => {
        setSharePops((prevDialogs) => ({
            ...prevDialogs,
            [type]: true
        }));
    };

    const handleShareClose = (type) => {
        setSharePops((prevDialogs) => ({
            ...prevDialogs,
            [type]: false
        }));
    };

    if (loading) {
        return (
            <div className="loader-container">
                <img src={loaderGif} alt="Loading..." height={100} width={100} />
            </div>
        );
    }
    const [firstName, lastName] = userDetails.name.split(' ');

    //based on ncard name only saving and Fetching
    const createLayoutProps = (cardType) => {
        const CardDetailsFilterByName = cardDetailsAll?.find((state) => state?.CardName === cardType);
        const CardDeailsForStyles = cardStylesAll?.find((state) => state?.CardName === cardType);
        const details = CardDetailsFilterByName;
        const styles = CardDeailsForStyles;
        return {
            profilePicture: details?.profile_pic || DefaultProfileBg,
            companyLogo: details?.logo || DefaultProfileBg,
            cardType,
            prefix: details?.prefix || '',
            suffix: details?.suffix || '',
            firstName: details?.firstName || '',
            lastName: details?.lastName || '',
            companyName: details?.company || '',
            designation: details?.designation || '',
            title: details?.title || '',
            colorPrimary: styles?.colorPrimary,
            colorSecondary: styles?.colorSecondary,
            colorTitle: styles?.colorTitle,
            bgColor: styles?.bgColor || "#ffff",
            layoutColor: styles?.colorLayout || "#0044C6B8",
            labelColor: '#ffffff',
            style: styles?.style || "Lato",

            phoneNo: userDetails.phone,
            emailId: userDetails.email,
            isVerified: details?.is_professional_verified || "false",

            //To variate at the end
            quantity: quantity,
            CardStylesofCard: styles,
            sharePops: sharePops,
            cardDetailsofCard: details,
            handleFavoriteClick: handleFavoriteClick,
            userDetails: userDetails,
            ContactStylesofCard: ContactStylesForGenZ,
            dialogs: dialogs,
            handleCloseDialog: handleCloseDialog,
            handleShareClose: handleShareClose,
            getFontWeight: getFontWeight,
            handleOpenDialog: handleOpenDialog,
            handleShareClick: handleShareClick
        };
    };

    const layoutStyleAll = (cardName, cardType) => {
        let currentLayout = cardStylesAll.find((card) => card.CardName === cardName);
        if (!currentLayout) {
            // console.warn(`No layout found for cardType: ${cardType}`);

            const initialCardStyles = {
                User_ID: objectId,
                CardType: cardType,
                CardName: cardName,
                font: '',
                size: '',
                style: '',
                colorPrimary: '',
                colorSecondary: '',
                colorTitle: '',
                colorLayout: '#0044c6',
                bgColor: '#ffff',
                layoutStyle: (cardType === 'Personal' || cardType === 'Customize_Personal') ? '2' : '1',
            };

            // Update the currentLayout with initialCardStyles
            currentLayout = initialCardStyles;
            if (cardType === "Customize_Personal" || cardType === "Personal") {
                console.log(`current log is ${cardName}`, currentLayout.layoutStyle);
                return currentLayout.layoutStyle || '2';
            }
            return currentLayout.layoutStyle || '1';
            // Return the layoutStyle value from the updated currentLayout
        } else {
            if (cardType === "Customize_Personal" || cardType === "Personal") {
                // console.log(`current log is ${cardType}`, currentLayout.layoutStyle);
                return currentLayout.layoutStyle || '2';
            }
            return currentLayout.layoutStyle || '1';
        }
    };

    return (
        <>
            {favoriteCards.length === 0 ? (
                <>
                    <div className='mt-5 d-flex align-items-center justify-content-center'>
                        <div className='no-fav-cards d-flex flex-column align-items-center justify-content-center'>
                            <div className='flex-center'>
                                <img src={Nofavourites} alt="" />
                            </div>
                            <h6 className='heading-fav text-center mt-2 mb-0'>There are no cards in your Favourites list</h6>
                            <p className='heading-fav-content text-center m-0'>Visit the Cards section to mark your favourite cards</p>
                            <Link to="/cards">
                                <button className='mt-2 fav-button'>Add to Favourites</button>
                            </Link>
                        </div>
                    </div>
                </>
            ) : (
                <div className="container-card-display">
                    <div className="items-container-card">

                        {AllCards.map(card => {
                            const isFavorite = favoriteCards.includes(card.card_name);
                            const layoutStyle = layoutStyleAll(card.card_name, card.card_Type);
                            const layoutProps = createLayoutProps(card.card_name);

                            return (
                                <div key={card.card_name}>
                                    {isFavorite && ['1', '2', '3', '4', '5', '6', '7', '8'].includes(layoutStyle) ? (
                                        AllCardLayouts(layoutStyle, layoutProps, card.card_name)
                                    ) : (
                                        // Render the default layout or something else for non-favorite cards
                                        <></>
                                    )}
                                </div>
                            );
                        })}

                        {/* {favoriteCards.map(favoriteCardName => {
                            const card = AllCards.find(card => card.card_name === favoriteCardName);
                            if (!card) return null; // Skip if card not found in otherCards

                            const layoutStyle = layoutStyleAll(card.card_type);
                            const layoutProps = createLayoutProps(card.card_name);

                            return (
                                <div key={card.card_name}>
                                    {['1', '2', '3', '4', '5', '6', '7', '8'].includes(layoutStyle) &&
                                        AllCardLayouts(layoutStyle, layoutProps, card.card_name)
                                    }
                                </div>
                            );
                        })} */}

                        {/* <div className={`item-card-display d-flex flex-column align-items-center justify-content-center digi-card-new  ${quantity === 1 ? "Smaller-screen" : ""}`}>
                            <a href="/cards" className='d-flex flex-column align-items-center justify-content-center create-new-card-select' style={{ height: "30%", width: "30%", cursor: "pointer" }}>
                                <div className={`icon plus-icon`}>
                                    <FaPlusCircle className="icon-color" />
                                </div>
                                <div className="text-nowrap icon-color">Add to Favourite</div>
                            </a>
                        </div> */}
                    </div>
                </div>
            )}

            <Box className="floating-dropdown-contacts" sx={{ position: 'relative', zIndex: 1, height: '100vh' }}>
                <Link to="/cards">
                    <Fab color="primary" aria-label="add" sx={{ position: 'fixed', bottom: 50, right: 50 }}>
                        <AddIcon />
                    </Fab>
                </Link>
            </Box>
        </>
    )
}

export default FavouriteCards